import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription, interval } from 'rxjs';
import { SpeechServiceService } from 'src/app/core/service/speech-service.service';
import { extractNumber, isEmptyObj } from 'src/app/helper/class/utilityHelper';
import { ResponseData } from 'src/app/helper/interface/response';
import { settings } from 'src/app/helper/interface/user';
import { AuthService } from 'src/app/helper/service/auth.service';
import { MasterApiService } from 'src/app/modules/master/service/master-api.service';
import { DashboardService } from 'src/app/modules/service/dashboard.service';

@Component({
  selector: 'app-token-display',
  templateUrl: './token-display.component.html',
  styleUrl: './token-display.component.scss'
})
export class TokenDisplayComponent implements OnInit, OnDestroy {
  displayId = '';
  displayData = '';
  settingData: any = {} as settings;
  tokenData: any[] = [];
  activeToken: any = {};
  apiSub !: Subscription;
  constructor(private activateRoute: ActivatedRoute,
    private auth: AuthService,
    private speechService: SpeechServiceService,
    private dashboardService: DashboardService,
    private masterApi: MasterApiService) { }
  ngOnDestroy(): void {
    this.apiSub?.unsubscribe();
  }
  ngOnInit(): void {
    this.displayId = this.activateRoute.snapshot.queryParams.id || '';
    this.getActiveToken();
    this.dashboardService.dashboardVariableChanges.subscribe(res => {
      switch (res.type) {
        case 'TOKEN':
          // this.tokenData = res.data.filter(a => a.counter_fk_id == this.displayId);
          // this.setActiveToken();
          break;
      }
    })
    // this.socketService.initSocket();
    this.dashboardService.stopApiSub();
    this.initSubApi();
  }
  initSubApi() {
    this.apiSub = interval(5000).subscribe((val) => {
      //call every 10 sec
      this.getActiveToken();
    });
  }
  setActiveToken(s: any) {
    // const s = this.tokenData.find(a => a.counter_fk_id == this.displayId && +a.status == 3) || {};
    console.log('activeToken', this.activeToken)
    if (!isEmptyObj(this.activeToken) && s.id != this.activeToken.id) {
      this.activeToken = s;
      this.makeVoice();
    } else if (isEmptyObj(this.activeToken)) {
      // this.activeToken = s;
      this.makeVoice();
    }
    this.activeToken = s;
  }

  playAudio() {
    const audio = document.getElementById('called_sound') as HTMLAudioElement;
    audio.play();
    return new Promise((resolve) => {
      audio.addEventListener('ended', () => {
        resolve(true)
      }, { once: true })
    })
  }

  async makeVoice() {
    if (!isEmptyObj(this.activeToken)) {
      //tigger voice /sound
      let tokenNumber: any = extractNumber(this.activeToken.token_no);
      const numberText = ["zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "ten"];
      const st = String(tokenNumber).split('');
      let token_text = '';
      st.forEach((e: any) => {
        if (e >= 0 && e <= 10) {
          token_text = `${token_text} ${numberText[e]}`;
        }
      });
      token_text = `Token Number ,   ${token_text}. Please proceed ${this.activeToken.counterName}`;
      const audio = await this.playAudio()
      if (audio) {
        this.speechService.start(token_text);
      }
      // this.speechService.start(token_text);
    }
  }
  dataLoading = false;
  getActiveToken() {
    if (this.dataLoading) {
      return
    }
    this.dataLoading = true
    this.settingData = this.auth.currentSettingValue;
    if (this.displayId) {
      this.dashboardService.getActiveTokenByCounterApi(this.displayId).then((res: ResponseData) => {
        this.setActiveToken(res.result);
      }).finally(() => this.dataLoading = false)
    }
  }

  openFullScreen(el: HTMLElement) {
    const elem = el;
    if (!document.fullscreenElement) {
      elem.requestFullscreen();
    } else if (document.exitFullscreen) {
      document.exitFullscreen()
    }
  }
}
